import React, { useImperativeHandle, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import Loading from "../Loading";
import { Button, Checkbox, Input } from "../Elements";
import Modal from "../Modal";
import commonNetwork from "../../../common/api/commonNetwork";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getNavigationUrl } from "../../../common/helpers/navigationHelpers";


type Props = {
    vpId: number
}

export interface CommissionHtmlTableRefProps {
    openModal: (vpId?: number) => void
}
const CommissionHtmlTable = React.forwardRef<CommissionHtmlTableRefProps, Props>((props: Props, ref) => {

    const navigate = useNavigate();
    const goToPosConnectionSettings = getNavigationUrl("/pos-baglanti-ayarlari");

    const { vpId } = props;
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [htmlTable, setHtmlTable] = useState("");
    const [loadingVisible, setLoadingVisible] = useState(false);
    const [isApplyToCustomer, setIsApplyToCustomer] = useState<boolean>(false);
    useImperativeHandle(ref, () => ({

        openModal(vpId) {
            selectHtmlTable(vpId);
            setIsModalVisible(true);
            setLoadingVisible(true);
            setHtmlTable("");

        }

    }));

    const selectHtmlTable = async (vpId?: number) => {
        const params = {
            vpId: vpId,
        }

        const response = await commonNetwork.get("/installment/get-installment-rates-from-bank", params);
        setLoadingVisible(false);

        if (response?.isSuccess) {
            setHtmlTable(response?.data);
        }

    };

    const postCommissionRates = async () => {
        try {
            setLoadingVisible(true);
            const params = {
                vpId: vpId,
                isApplyToCustomer: isApplyToCustomer
            }
            const response = await commonNetwork.post("/installment/save-installment-rates-from-bank", params);
            if (response.isSuccess) {
                setLoadingVisible(false);
                navigate(goToPosConnectionSettings);
                toast.success("Hizmet Komisyon Oranları başarılı bir şekilde kaydedilmiştir.");
            } else {
                setLoadingVisible(false);
                toast.error(response.data.message || "Komisyon oranları kaydedilirken bir hata oluştu.");
            }

        } catch (error) {

        }
    };

    return (
        <Modal dialogclassName={"!max-w-[1200px] !mt-16"} openModal={isModalVisible} setOpenModal={() => setIsModalVisible(false)} >
            <div>
                <div className="sm:flex sm:items-start">
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-[100%] min-w-[400px] min-h-[450px]">
                        <div className="flex justify-between">
                            <div></div>
                            <h3 className="text-md leading-6 font-medium text-gray-900">
                                Hizmet Komisyon Oranları
                            </h3>
                            <div>

                                <FontAwesomeIcon icon={faXmark} className="cursor-pointer" fontSize={18} onClick={() => setIsModalVisible(false)} />

                            </div>
                        </div>

                        {(loadingVisible) && (
                            <Loading desc="Komisyon oranları yükleniyor..." />
                        )}
                        <div dangerouslySetInnerHTML={{
                            __html: htmlTable
                        }}>

                        </div>
                    </div>
                </div>
                <div className="mt-2 sm:mt-4 flex justify-end space-x-2">
                    <Checkbox
                        onClickLabel={() => {
                            setIsApplyToCustomer(!isApplyToCustomer);
                        }}
                        checked={isApplyToCustomer}
                        type="checkbox"
                        label={"Müşteriye Yansıtılacak Komisyon Oranlarını Güncelle"}
                        disabled={loadingVisible}
                        onChange={(e: any) => {
                            setIsApplyToCustomer(e.target.checked);
                        }}
                    />
                </div>
                <div className="mt-3 sm:mt-4 flex justify-end space-x-2">
                    <Button
                        color="gray"
                        hover="gray"
                        size="xs"
                        disabled={loadingVisible}
                        callback={() => setIsModalVisible(false)}
                        loading={loadingVisible}
                    >
                        Kapat
                    </Button>
                    <Button
                        color="primary"
                        hover="primary"
                        size="xs"
                        callback={() => postCommissionRates()}
                        disabled={loadingVisible}
                        loading={loadingVisible}
                    >
                        Hizmet Komisyon Oranlarını Güncelle
                    </Button>
                </div>
            </div>
        </Modal>
    );
})

export default CommissionHtmlTable;


String.prototype.replaceAll = function (search: any, replacement: any) {
    var target = this;
    var result: string = target.split(search).join(replacement);
    return result;
};